module.exports = __webpack_public_path__ + "static/media/Active.2c7ab667.svg";